import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-reason-dialog',
    templateUrl: './reason-dialog.component.html',
    styleUrls: ['./reason-dialog.component.scss']
})
export class ReasonDialogComponent implements OnInit {

    @Output() closeDialog: EventEmitter<string>;
    @Output() confirmDialog: EventEmitter<string>;
    public reason: string = '';

    constructor() {
        this.closeDialog = new EventEmitter<string>();
    }

    ngOnInit(): void {
    }

    public updateReason(reason: string): void {
        this.reason = reason;
    }

    public sendConfirmDialog(reason: string): void {
        this.confirmDialog.emit(reason);
    }

    public sendCloseDialog(action: string): void {
        if (action === 'confirm') {
            this.closeDialog.emit(this.reason);
        } else {
            this.closeDialog.emit(null);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/presentation/reason-dialog/reason-dialog.component.ts